// extracted by mini-css-extract-plugin
module.exports = {"mainBlue":"#0080d1","mainGreen":"#008045"};